module.exports = {
  SWITCH_LANGUAGE: 'SWITCH_LANGUAGE'
};




// WEBPACK FOOTER //
// ./src/components/language/action_types.js